import { Inject, Injectable } from '@angular/core';

import {
    EnvironmentInterface,
    GlobalsClientInterface,
    UserClientType,
    UserNotificationInterface
} from '@guardfinder/shared';

@Injectable()
export class Globals implements GlobalsClientInterface {
    appType: 'client' | 'pro' = 'client';

    gMapsApi: string | null | undefined;
    token: string | null = null;
    user: UserClientType = null;
    notificationCount: number = 0;
    notifications: UserNotificationInterface[] = [];
    tosUrl: string = '/terms-of-use';
    ppUrl: string = '/privacy-policy';
    faqUrl: string = '/faq';
    companyPhoneNumber: string = '';
    companyPhoneNumberFormatted: string = '';
    companyName: string = 'GuardFinder';
    hideParkingFeeAfterDate: string = '';

    support = {
        phone: '+17322991013',
        phoneFormatted: '(732) 200-1013',
        email: 'info@guardfinder.com'
    };

    bookingSettings = {
        maxBookableMonths: 24,
        minimumBookableHours: 0.5,
        lastHourOfDayForBooking: 23,
        earliestHourOfDayForBooking: 0
    };

    constructor(@Inject('environment') environment: EnvironmentInterface) {
        this.gMapsApi = environment.googleMapsApiKey;
        this.tosUrl = environment.website + this.tosUrl;
        this.ppUrl = environment.website + this.ppUrl;
        this.faqUrl = environment.website + this.faqUrl;
    }
}
